import { makeStyles, tokens } from "@fluentui/react-components";

export const useSearchHistoryCardStyles = makeStyles({
  historyCard: {
    minHeight: "105px",
    backgroundColor: "#eeeeee",
    color: "#777777",
    marginBottom: "15px",
    ":hover": {
      backgroundColor: "white",
      "& *": {
        color: "black",
      },
    },
  },
  historyCardAction: {
    color: tokens.colorBrandBackground,
    textWrap: "nowrap",
    ":hover": {
      backgroundColor: tokens.colorBrandBackground2,
      color: tokens.colorBrandBackground,
    },
  },
  tagNavy: {
    color: "#777777",
    border: `${tokens.colorPaletteRoyalBlueForeground2}`,
    textOverflow: "ellipsis",
    textWrap: "nowrap",
  },
  headerTagsContainer: {
    display: "flex",
    flexDirection: "row",
    columnGap: "15px",
  },
  searchText: {
    textOverflow: "ellipsis",
  },
  footerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  buttonGroup: {
    display: "flex",
  },
});
